export default "__VITE_ASSET__6rb63x72__"